import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { useAuth } from "../helper/useAuth";

export interface IReactivateSubscriptionResponse {
  message: string;
  cancel_at_period_end: boolean;
  current_period_end: string;
}

export const useReactivateSubscription = () => {
  const queryClient = useQueryClient();
  const { refreshUser } = useAuth();

  return useMutation<IReactivateSubscriptionResponse, Error, void>({
    mutationFn: async () => {
      return await httpService.post<IReactivateSubscriptionResponse>(
        API_CONFIG.path.stripeReactivate,
        {}
      );
    },
    onSuccess: () => {
      refreshUser();
      queryClient.invalidateQueries({ queryKey: ["stripe", "history"] });
    },
  });
};
